import * as React from "react";
import { Table } from "semantic-ui-react";

const TableDetail: React.FunctionComponent<{name: string; value: string}> = (props) => (
    <Table.Row>
        <Table.Cell width="6">
            <strong>{props.name}</strong>
        </Table.Cell>
        <Table.Cell width="10">
            {props.value}
        </Table.Cell>
    </Table.Row>
);

export { TableDetail };
